/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const BoardScoreOutline = createIcon({
  displayName: 'BoardScoreOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g id="Layer_2" data-name="Layer 2">
        <rect width="24" height="24" fill="none" />
        <rect
          x="2"
          y="7"
          width="20"
          height="14"
          rx="2"
          strokeWidth="1.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <line
          x1="16"
          y1="12.25"
          x2="17"
          y2="12.25"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="17"
          y1="12.25"
          x2="17"
          y2="15.75"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="16"
          y1="15.75"
          x2="18"
          y2="15.75"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <rect
          x="5.5"
          y="12.25"
          width="3"
          height="3.5"
          rx="0.5"
          strokeWidth="1.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <line
          x1="12"
          y1="7"
          x2="12"
          y2="21"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="6"
          y1="7"
          x2="6"
          y2="3"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="18"
          y1="7"
          x2="18"
          y2="3"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </>
  ),
})

const BoardScore: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    default:
      return <CustomIcon as={BoardScoreOutline} {...props} />
  }
}

export default memo(BoardScore)
